import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./About.css";

const staggerContainer = { hidden: { opacity: 0 }, visible: { opacity: 1, transition: { staggerChildren: 0.2 } } };
const slideInLeft = { hidden: { opacity: 0, x: -50 }, visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } } };
const scaleIn = { hidden: { opacity: 0, scale: 0.8 }, visible: { opacity: 1, scale: 1, transition: { duration: 0.8, ease: "easeOut" } } };

const ChevronUpIcon = ({ isOpen }) => (
    <svg 
        width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#003049" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        style={{ transform: isOpen ? "rotate(0deg)" : "rotate(180deg)", transition: "transform 0.3s ease" }}
    >
        <polyline points="18 15 12 9 6 15"></polyline>
    </svg>
);

export default function About() {
  const [knowImageHover, setKnowImageHover] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [expandedSlide, setExpandedSlide] = useState(0);
  
  const slides = [
    {
      title: "What is Nabi?",
      text: "It’s a preventive and supportive emotional well-being space, built around reflection: understanding one’s thoughts, feelings, emotions and one’s actions and how it impacts oneself and others."
    },
    {
      title: "Why Nabi?",
      text: "Nabi is not here to tell you what to feel, but to hold up a mirror: giving you room to notice, name and navigate your inner world at your own pace."
    },
    {
      title: "Nabi & Access.",
      text: "Nabi is designed to make psychological health and safety accessible by removing the barriers to it: Our goal is to meet where you are; whenever you choose to check in with yourself and however you choose to seek support."
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  useEffect(() => {
    const id = setInterval(nextSlide, 18000);
    return () => clearInterval(id);
  }, []);
    
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="about-page">
      <motion.section 
          className="know-section"
          initial="hidden" whileInView="visible" viewport={{ once: true }} variants={staggerContainer}
      >
        <motion.div className="know-text" variants={slideInLeft}>
          <h2 className="know-heading">"Know Thyself"</h2>
          <p className="know-para">
            Nabi is built around the philosophy of “Know and be yourself”: the belief that knowing yourself begins, not through external pressure, but through reflection. To know yourself, to understand yourself: is the first meaningful growth and to truly be your unique self.
          </p>
          <br/>
          <p className="know-para">
            Our purpose is to create a community where people feel safe to explore and talk about their emotions, because, by being true to our nature, we understand ourselves better and we do better and that creates a positive effect within oneself and on others.  
          </p>
        </motion.div>
        <motion.div 
          variants={scaleIn} 
          className="know-image-container"
          onMouseEnter={() => setKnowImageHover(true)}
          onMouseLeave={() => setKnowImageHover(false)}
        >
          <img 
            src="image2.png" 
            alt="Know Thyself Landscape" 
            className="know-image"
            style={{ opacity: knowImageHover ? 0 : 1}} 
          />
          <img 
            src="image3.png" 
            alt="Know Thyself Landscape Hover" 
            className="know-image"
            style={{ position: 'absolute', inset: 0, opacity: knowImageHover ? 1 : 0}} 
          />
        </motion.div>
      </motion.section> 

      {/* 
      <section className="slider-section">
        <div className="slider-container">
          <button onClick={prevSlide} className="arrow-btn">‹</button>
          <motion.div 
            key={currentSlide}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
            className="slide-card"
          >
            <h3 className="slide-title">{slides[currentSlide].title}</h3>
            <p className="slide-text">{slides[currentSlide].text}</p>
          </motion.div>
          <button onClick={nextSlide} className="arrow-btn">›</button>
        </div>
        <div className="dots-container">
          {slides.map((_, idx) => (
            <div key={idx} className="dot" style={{ backgroundColor: idx === currentSlide ? '#333' : 'rgba(0,0,0,0.2)'}} />
          ))}
        </div>
      </section> 
      */}

      {/* Accordion Section */}
      <section className="accordion-section">
        <div className="accordion-container">
          {slides.map((slide, idx) => (
            <div key={idx} className="accordion-item">
              <button 
                className="accordion-header" 
                onClick={() => setExpandedSlide(expandedSlide === idx ? null : idx)}
              >
                <h3 className="accordion-title">{slide.title}</h3>
                <ChevronUpIcon isOpen={expandedSlide === idx} />
              </button>
              <AnimatePresence>
                {expandedSlide === idx && (
                  <motion.div 
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                    className="accordion-content"
                  >
                    <p className="accordion-text">{slide.text}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
